/**
 * @link https://span.studio
 * @copyright Copyright (c) Span Studio LLC
 * @license https://github.com/Span-Studio/sta100-craft5/blob/main/LICENSE.md
 * 
 * CheckboxToggleData
 * Toggles custom checkboxes.
 * Used within judging templates.
 * 
 * @author John Pobojewski <https://john.pobojewski.com>
 */

class CheckboxToggleData {
	constructor() {}

	init(c, nameVal, type) {
		console.log("CheckboxToggleData.init()");

		const checkboxes = document.querySelectorAll(`input.${c}`);
		checkboxes.forEach((checkbox) => {
			checkbox.addEventListener("change", function () {
				const dataValue = this.getAttribute("data-value");
				const dataSrc = this.getAttribute("data-src");

				// Remove existing hidden input with matching value
				const existingHidden = document.querySelectorAll(`input[type="hidden"][value="${dataValue}"]`);
				existingHidden.forEach((el) => el.remove());

				if (this.checked) {
					const input = document.createElement("input");
					input.type = "hidden";
					input.name = type === "array" ? `${nameVal}[]` : nameVal;
					input.value = dataValue;
					input.setAttribute("data-target", dataSrc);
					this.parentNode.insertBefore(input, this);
				} else {
					if (type === "array") {
						const siblings = document.querySelectorAll(`input[type="hidden"][name="${nameVal}[]"]`);
						if (siblings.length === 0) {
							const input = document.createElement("input");
							input.type = "hidden";
							input.name = nameVal;
							input.value = "";
							this.parentNode.insertBefore(input, this);
						}
					} else {
						const input = document.createElement("input");
						input.type = "hidden";
						input.name = nameVal;
						input.value = "";
						this.parentNode.insertBefore(input, this);
					}
				}
			});
		});
	}
}

export default new CheckboxToggleData();
